var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83268 34.1673C5.8931 34.1673 5.08904 33.833 4.42052 33.1645C3.75199 32.496 3.41715 31.6914 3.41602 30.7506V10.2506C3.41602 9.31107 3.75085 8.50701 4.42052 7.83848C5.09018 7.16996 5.89424 6.83512 6.83268 6.83398H34.166C35.1056 6.83398 35.9102 7.16882 36.5799 7.83848C37.2496 8.50815 37.5838 9.31221 37.5827 10.2506V30.7506C37.5827 31.6902 37.2484 32.4949 36.5799 33.1645C35.9114 33.8342 35.1067 34.1684 34.166 34.1673H6.83268ZM20.4993 22.209L6.83268 13.6673V30.7506H34.166V13.6673L20.4993 22.209ZM20.4993 18.7923L34.166 10.2506H6.83268L20.4993 18.7923ZM6.83268 13.6673V10.2506V30.7506V13.6673Z",
    fill: "#4E4E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a085c55889f04e885123b905b8821c89.svg";
export { ForwardRef as ReactComponent };